export default class Session {
    //sempre que forem adicionados novos atributos, lembrar de declarar o clean do value no logout
    constructor(idToken='', accessToken='', refreshToken='', grupoUsuario='') {

        this.idToken = idToken;
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        this.grupoUsuario = grupoUsuario;
    }
}


// WEBPACK FOOTER //
// ./src/domain/login/Session.js